import React from 'react';
import styles from '../../styles/product/product-content.module.css';
import Cookies from 'js-cookie';
import { StaticQuery, graphql } from 'gatsby';

const jwt_decode = require('jwt-decode');

class ProductCta extends React.Component {
  constructor(props) {
    super(props);
    if (this.props.cta && this.props.cta != '') {
      this.state = { cta: this.props.cta };
    } else {
      this.state = { cta: 'Request a Demo' };
    }
    //Reset all the cookies for the cta
    Cookies.set('mv-createlisting-redirect', false);
    Cookies.remove('mv-createlisting-redirect');
    Cookies.set('mv-mashboard-redirect', false);
    Cookies.remove('mv-mashboard-redirect');
    Cookies.set('mv-marketplace-redirect', false);
    Cookies.remove('mv-marketplace-redirect');
  }

  //check if the user is registered
  componentDidMount() {
    try {
      var decodedCookie;
      decodedCookie = jwt_decode(Cookies.get('squanchy'));
      decodedCookie.user
        ? this.setState({ squanchy: true })
        : this.setState({ squanchy: false });
    } catch (err) {
      this.setState({ ...this.state, squanchy: false });
    }
  }

  //Redirect each cta to its route
  ctaRedirection(mashvisorDomain, mashboardDomain) {
    if (this.state.cta == 'Request a Demo') {
      this.openCalendly();
    } else if (
      this.state.cta.toLowerCase() === 'go to marketplace' ||
      this.state.cta.toLowerCase() === 'visit the marketplace'
    ) {
      this.marketplaceRedirection(mashvisorDomain, mashboardDomain);
    } else if (this.state.cta.toLowerCase() == 'create a listing') {
      this.createListingsRedirection(mashvisorDomain, mashboardDomain);
    } else if (this.state.cta.toLowerCase() == 'visit your mashboard') {
      this.mashboardRedirection(mashvisorDomain, mashboardDomain);
    } else if (this.state.cta.toLowerCase() == 'start free trial') {
      this.freeTrial(mashvisorDomain);
    } else if (this.state.cta.toLowerCase() == 'upgrade now') {
      this.upgradeNow(mashvisorDomain);
    }
  }

  //Redirect to  marketplace
  marketplaceRedirection(mashvisorDomain, mashboardDomain) {
    if (this.state.squanchy && this.state.squanchy == true) {
      window.location.href = mashboardDomain + '/v2/property-marketplace';
    } else {
      Cookies.set('mv-createlisting-redirect', false);
      Cookies.remove('mv-createlisting-redirect');
      Cookies.set('mv-mashboard-redirect', false);
      Cookies.remove('mv-mashboard-redirect');
      Cookies.set('mv-marketplace-redirect', true);
      this.searchAppRedirection(mashvisorDomain);
    }
  }

  //Redirect to  properties in mashboard
  createListingsRedirection(mashvisorDomain, mashboardDomain) {
    if (this.state.squanchy && this.state.squanchy == true) {
      window.location.href = mashboardDomain + '/v2/properties';
    } else {
      Cookies.set('mv-marketplace-redirect', false);
      Cookies.remove('mv-marketplace-redirect');
      Cookies.set('mv-mashboard-redirect', false);
      Cookies.remove('mv-mashboard-redirect');
      Cookies.set('mv-createlisting-redirect', true);
      this.searchAppRedirection(mashvisorDomain);
    }
  }

  //Redirect to contacts in mashboard
  mashboardRedirection(mashvisorDomain, mashboardDomain) {
    if (this.state.squanchy && this.state.squanchy == true) {
      window.location.href = mashboardDomain + '/v2/contacts';
    } else {
      Cookies.set('mv-createlisting-redirect', false);
      Cookies.remove('mv-createlisting-redirect');
      Cookies.set('mv-marketplace-redirect', false);
      Cookies.remove('mv-marketplace-redirect');
      Cookies.set('mv-mashboard-redirect', true);
      this.searchAppRedirection(mashvisorDomain);
    }
  }

  //Redirect to search app
  searchAppRedirection(mashvisorDomain) {
    setTimeout(() => {
      window.location.href = mashvisorDomain + '/explore/search';
    }, 1000);
  }

  //Redirect to free trial checkout
  freeTrial(mashvisorDomain) {
    setTimeout(() => {
      window.location.href =
        mashvisorDomain + '/checkout#?plan=Standard_Quarterly&amp;coupon=7DAY';
    }, 1000);
  }
  //Redirect to checkout no trial
  upgradeNow(mashvisorDomain) {
    setTimeout(() => {
      window.location.href =
        mashvisorDomain + '/checkout#?plan=STANDARD_Quarterly';
    }, 1000);
  }

  isMyScriptLoaded = url => {
    var scripts = document.getElementsByTagName('script');
    for (var i = scripts.length; i--; ) {
      if (scripts[i].src === url) {
        return true;
      }
    }
    return false;
  };

  openCalendly() {
    if (
      this.isMyScriptLoaded('https://calendly.com/assets/external/widget.js')
    ) {
      window.Calendly.showPopupWidget('https://calendly.com/mashvisor/demo');
      let pageEventName = this.props.pageTitle.replace(/\s/g, '');

      window.gtag('event', pageEventName + ':PageBody', {
        'event_category': 'pageEventName',
        'event_label': pageEventName + ':PageBody:DemoRequest'
      });
 
      return false;
    }
  }

  render() {
    return (
      <StaticQuery
        query={detailsQuery}
        render={data => {
          return (
            <a
              className={`${styles.areaButton} trial-experimental-upgrade`}

            
              href='/demo-request'
            >
              {this.state.cta}
            </a>
          );
        }}
      />
    );
  }
}
const detailsQuery = graphql`
  query DefaultSEOQuery3 {
    site {
      siteMetadata {
        mashvisorDomain
        mashboardDomain
      }
    }
  }
`;
export default ProductCta;
